import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ICondicionalRelease } from '../interfaces/condicional/icondicional.release';
import { ICondicionalTrigger } from '../interfaces/condicional/icondicional.trigger';

@Injectable({
  providedIn: 'root'
})
export class ConditionalService {

  constructor(private http: HttpClient) { }

  getRelease(clientId: number) {
    return this.http
      .get(`https://api-fake-r9p5.onrender.com/clientServiceReleaseSetting/${clientId}`)
      .pipe(map((res: any) => res)) as Observable<ICondicionalRelease>;
    /* .pipe(map((res: any) => res['hydra:member'])) as Observable<ICondicionalRelease>; */
  }

  getTrigger(clientId: number) {
    return this.http
      .get(`https://api-fake-r9p5.onrender.com/trigger_release_setting/${clientId}`)
      .pipe(map((res: any) => res)) as Observable<ICondicionalTrigger>;
    /* .pipe(map((res: any) => res['hydra:member'])) as Observable<ICondicionalTrigger>; */
  }

  editRelease(req: ICondicionalRelease, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json', });

    return this.http.patch(
      `https://api-fake-r9p5.onrender.com/clientServiceReleaseSetting/${id}`, req, { headers: headers }
    ) as Observable<ICondicionalRelease>;
  }

  editTrigger(req: ICondicionalTrigger, id: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json', });

    return this.http.patch(
      `https://api-fake-r9p5.onrender.com/trigger_release_setting/${id}`, req, { headers: headers }
    ) as Observable<ICondicionalTrigger>;
  }
}
